import { select, mouse, drag, line, event, selectAll } from "d3";

let gTrendLines;

const updateOrCreateData = (
  pointStart = null,
  pointEnd = null,
  i,
  colorTrendLine = null,
  _this
) => {
  const newObj = {};
  const rescaledX = _this.transform.rescaleX(_this.svgNode.x);

  const createTrendlineObject = point => ({
    date: rescaledX.invert(point[0]),
    close: _this.svgNode.y.invert(point[1])
  });

  /* Checks if the line exists or creates the line */
  if (pointStart !== null && pointEnd !== null) {
    newObj[`start${i}`] = createTrendlineObject(pointStart);
    newObj[`end${i}`] = createTrendlineObject(pointEnd);
    newObj["id"] = i;
    newObj["color"] = colorTrendLine;
    newObj["idChart"] = !_this.isCurrency
      ? _this.commodityName
      : _this.selectedCurrency;
  } else if (pointStart !== null) {
    newObj[`start${i}`] = createTrendlineObject(pointStart);
  } else {
    newObj[`end${i}`] = createTrendlineObject(pointEnd);
  }
  const allTrendLineData = _this.trendLineData;
  const index = allTrendLineData.findIndex(
    key => key[`start${i}`] && key[`end${i}`]
  );

  /* Check if this line exists in the array */
  const hasStartKey = allTrendLineData.some(obj =>
    Object.prototype.hasOwnProperty.call(obj, `start${i}`)
  );

  /* Create or update the object */
  if (!hasStartKey) {
    allTrendLineData.push(newObj);
  } else {
    allTrendLineData.splice(index, 1, {
      ...allTrendLineData[index],
      ...newObj
    });
  }
};

export const trendLine = (
  _this,
  createTrendLine,
  colorLine,
  colorStrokeCircle,
  chartName
) => {
  const straightLine = line()
    .x(d => _this.transform.rescaleX(_this.svgNode.x)(d.date))
    .y(d => _this.svgNode.y(d.close));

  const pointsTrendLines = {};
  gTrendLines = selectAll(`.hoverParentTA${chartName}`).append("g");
  let id;
  /* setting up the environment for drawing the trend line  */
  function setupLineDrawingEnvOnClick() {
    gTrendLines = selectAll(`.hoverParentTA${chartName}`).append("g");
    selectAll(`#${createTrendLine}${chartName} path`).classed("selected", true);
    id = new Date().getTime();

    pointsTrendLines[`start${id}`] = null;
    pointsTrendLines[`currentPoint${id}`] = null;
    pointsTrendLines[`end${id}`] = null;

    /* rectangle capture click and drag */
    _this.svgNode
      .append("rect")
      .attr("class", `rect-trendLine rect-line${id}`)
      .attr("width", _this.svgNode.width)
      .attr("height", _this.svgNode.height)
      .attr("fill", "none")
      .attr("pointer-events", "all")
      .on("mousedown", startLine)
      .on("mousemove", cursor);

    const cursorCustom = select("body")
      .append("div")
      .attr("class", `custom-cursor-trendLine`);

    const widthCursorCustom = cursorCustom.node().clientWidth / 2;

    function cursor() {
      const eventX = event.clientX - widthCursorCustom;
      const eventLayerX = event.layerX;
      const eventY = event.clientY - widthCursorCustom;
      const eventLayerY = event.layerY;

      if (
        eventLayerX >= _this.svgNode.width ||
        eventLayerY >= _this.svgNode.height ||
        eventLayerX - widthCursorCustom <= 0 ||
        eventLayerY - widthCursorCustom <= 0
      ) {
        select(".custom-cursor-trendLine").style("display", "none");
      } else {
        select(".custom-cursor-trendLine")
          .style("display", "block")
          .style("left", `${eventX}px`)
          .style("top", `${eventY}px`);
      }
    }

    const groupTrendLine = gTrendLines
      .append("g")
      .attr("class", `g-trend g-trend${id}`);

    /* Selects the color of the trend line */
    const qtyTrendLines = selectAll(".g-trend").nodes();
    let newCol;
    qtyTrendLines.forEach(
      (qty, i) => (newCol = colorLine[i % colorLine.length])
    );

    // Creates the start trend line and start circle
    function startLine() {
      if (pointsTrendLines[`start${id}`]) {
        return;
      }
      pointsTrendLines[`start${id}`] = mouse(this);

      createCircle(
        id,
        _this,
        newCol,
        "start",
        groupTrendLine,
        straightLine,
        colorStrokeCircle,
        pointsTrendLines
      );

      _this.svgNode.on("mousemove", drawLine);
      _this.svgNode.on("mouseup", endLine);
    }

    /* Drawing the trend line */
    function drawLine() {
      pointsTrendLines[`currentPoint${id}`] = mouse(this);
      selectAll(`.trendLine${id}`).remove();

      updateOrCreateData(
        pointsTrendLines[`start${id}`],
        pointsTrendLines[`currentPoint${id}`],
        id,
        newCol,
        _this
      );
      createLine(
        _this,
        groupTrendLine,
        id,
        straightLine,
        newCol,
        colorStrokeCircle
      );
    }

    /* Creates the end circle */
    function endLine() {
      selectAll(`.rect-line${id}`).remove();
      selectAll(`.custom-cursor-trendLine`).remove();
      pointsTrendLines[`end${id}`] = mouse(this);
      createCircle(
        id,
        _this,
        newCol,
        "end",
        groupTrendLine,
        straightLine,
        colorStrokeCircle,
        pointsTrendLines
      );

      groupTrendLine
        .selectAll("circle")
        .transition()
        .duration(200)
        .attr("r", 1.5);

      selectAll(`#${createTrendLine}${chartName} path`).classed(
        "selected",
        false
      );
      _this.svgNode.on("mousemove", null);
      _this.svgNode.on("mouseup", null);

      const selectGroupTrendLine = select(`.g-trend${id}`);
      const hasTrendLine = selectGroupTrendLine.select("path");
      if (hasTrendLine.empty()) {
        selectGroupTrendLine
          .transition()
          .duration(250)
          .remove();
      }
    }
  }
  /* Cancel the trend line draw */
  function cancelDrawing() {
    selectAll(`.rect-line${id}`).remove();
    selectAll(`#${createTrendLine}${chartName} path`).classed(
      "selected",
      false
    );
    _this.svgNode.on("mousemove", null);
    _this.svgNode.on("mouseup", null);
    selectAll(`.custom-cursor-trendLine`).remove();
  }
  /* Button for create a trend line */
  const btnTrendLine = selectAll(`#${createTrendLine}${chartName}`);

  btnTrendLine.on("click", () => {
    if (selectAll(`#${createTrendLine}${chartName} path`).classed("selected")) {
      cancelDrawing();
    } else {
      setupLineDrawingEnvOnClick();
    }
  });
};
/* Dragged the trend line or each point */
function dragged(straightLine, _this, colorStrokeCircle) {
  function dragStarted() {
    select(this).attr("stroke", colorStrokeCircle);
  }

  function dragged() {
    const circle = select(this);
    const { x, y, dx, dy } = event;
    const circleClass = circle.attr("class");
    const regExp = /[0-9]/g;
    const lastIndex = [...circleClass.matchAll(regExp)].length;

    const id = circleClass
      .slice(circleClass.search(regExp))
      .slice(0, lastIndex);

    const trendLine = select(`.trendLine${id}`);

    const updateCircle = (circle, cx, cy) => {
      if (circle.classed("circle-start")) {
        updateOrCreateData([cx, cy], null, id, null, _this);
      } else if (circle.classed("circle-end")) {
        updateOrCreateData(null, [cx, cy], id, null, _this);
      }
      circle.attr("cx", cx).attr("cy", cy);
    };

    if (circle.classed("circle-start") || circle.classed("circle-end")) {
      updateCircle(circle, x, y);
    } else {
      selectAll(`.circle-start${id}, .circle-end${id}`).each(function() {
        const circle = select(this);
        const cx = +circle.attr("cx") + dx;
        const cy = +circle.attr("cy") + dy;
        updateCircle(circle, cx, cy);
      });
    }
    const data = _this.trendLineData.find(
      value => value[`start${id}`] && value[`end${id}`]
    );
    parseData(_this.trendLineData);
    trendLine.attr("d", () =>
      straightLine([data[`start${id}`], data[`end${id}`]])
    );
  }
  function dragEnded() {
    select(this).attr("stroke", null);
  }
  return drag()
    .on("start", dragStarted)
    .on("drag", dragged)
    .on("end", dragEnded);
}
/* Create a circle */
function createCircle(
  id,
  _this,
  colorLine,
  classed,
  groupTrendLine,
  straightLine,
  colorStrokeCircle,
  pointsTrendLines = null,
  position = null,
  d = null
) {
  const isPointsTrendLine =
    pointsTrendLines && pointsTrendLines[`${classed}${id}`];

  groupTrendLine
    .append("circle")
    .attr("class", `circle-${classed} circle-${classed}${id}`)
    .attr(
      "cx",
      pointsTrendLines ? isPointsTrendLine[0] : () => _this.xt(d[position].date)
    )
    .attr(
      "cy",
      pointsTrendLines
        ? isPointsTrendLine[1]
        : () => _this.svgNode.y(d[position].close)
    )
    .attr("r", pointsTrendLines ? 3 : 1.5)
    .style("fill", () => colorLine)
    .style("shape-rendering", "crispEdges")
    .style("vector-effect", "non-scaling-stroke");

  _this.svgNode
    .selectAll("circle")
    .call(dragged(straightLine, _this, colorStrokeCircle));
}
/* Create a trend line - path */
function createLine(
  _this,
  groupTrendLine,
  id,
  straightLine,
  colorLine,
  colorStrokeCircle
) {
  const data = filterTrendLineData(_this);
  groupTrendLine
    .append("path")
    .data([data])
    .attr("class", `trendLine trendLine${id}`)
    .attr("d", d => {
      const data = d.find(value => value[`start${id}`] && value[`end${id}`]);
      return straightLine([data[`start${id}`], data[`end${id}`]]);
    })
    .style("stroke", () => colorLine)
    .style("stroke-width", 1.5)
    .style("cursor", "move")
    .style("shape-rendering", "crispEdges")
    .style("vector-effect", "non-scaling-stroke");

  select(`.trendLine${id}`).on("click", function() {
    selectAll(".trendLine").classed("selected", false);
    selectAll(".g-trend").classed("selected", false);
    select(this).classed("selected", true);
    select(`.g-trend${id}`).classed("selected", true);
  });

  _this.svgNode
    .selectAll(".g-trend")
    .call(dragged(straightLine, _this, colorStrokeCircle));
}
/* Parse the trend line data */
function parseData(data) {
  data.forEach(d => {
    Object.keys(d).forEach(key => {
      if (d[key] && d[key].date) {
        d[key].date = new Date(d[key].date);
      }
    });
  });
}
/* Filter data with the asset selected by the user*/
export function filterTrendLineData(_this) {
  const isCurrency = !_this.isCurrency
    ? _this.commodityName
    : _this.selectedCurrency;
  return _this.trendLineData.filter(d => isCurrency === d.idChart);
}
/* gets and paints the existing trend lines */
export const getTrendLineData = (_this, colorStrokeCircle) => {
  const straightLine = line()
    .x(d => _this.transform.rescaleX(_this.svgNode.x)(d.date))
    .y(d => _this.svgNode.y(d.close));

  const data = filterTrendLineData(_this);
  if (data) {
    data.forEach(d => {
      const [start, end] = Object.keys(d);
      const id = start.slice(start.search(/[0-9]/));

      const groupTrendLine = gTrendLines
        .append("g")
        .attr("class", `g-trend g-trend${id}`);
      parseData(_this.trendLineData);
      createCircle(
        id,
        _this,
        d["color"],
        "start",
        groupTrendLine,
        straightLine,
        colorStrokeCircle,
        null,
        start,
        d
      );
      createLine(
        _this,
        groupTrendLine,
        id,
        straightLine,
        d["color"],
        colorStrokeCircle
      );
      createCircle(
        id,
        _this,
        d["color"],
        "end",
        groupTrendLine,
        straightLine,
        colorStrokeCircle,
        null,
        end,
        d
      );
    });
  }
};
